import PropTypes from 'prop-types';
import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

const Chrome = ({ width, color }) => (
  <svg width={width} height={width} viewBox="222 3 37 38">
    <path
      fill={color}
      fillRule="evenodd"
      d="M234.87 21.5c0-1.57.546-2.9 1.638-3.992 1.093-1.092 2.423-1.638 3.992-1.638 1.57 0 2.9.546 3.992 1.638 1.092 1.093 1.638 2.423 1.638 3.992 0 1.57-.546 2.9-1.638 3.992-1.093 1.092-2.423 1.638-3.992 1.638-1.57 0-2.9-.546-3.992-1.638-1.092-1.093-1.638-2.423-1.638-3.992zm23.878-3.226c.168.995.252 2.046.252 3.15 0 4.37-1.372 8.238-4.115 11.61-2.744 3.373-6.244 5.53-10.5 6.468-1.12.222-1.96.36-2.52.415-.39.055-.95.083-1.678.083-.952 0-1.652-.028-2.1-.083v-.083l8.567-14.677c.728-1.16 1.092-2.405 1.092-3.732 0-2.1-.896-3.952-2.688-5.555h13.102c.168.497.364 1.3.588 2.404-.224-1.105-.42-1.907-.588-2.404.168.497.364 1.3.588 2.404zM240.516 28.5c.77 0 1.57-.136 2.397-.41l-6.447 11.106c-3.417-.713-6.393-2.33-8.928-4.854C223.846 30.777 222 26.39 222 21.18c0-2.632.496-5.045 1.488-7.24.55-1.206 1.267-2.44 2.15-3.7l8.513 14.642c1.434 2.413 3.555 3.62 6.366 3.62zm-13.69-19.514v-.082c2.093-2.24 4.57-3.854 7.435-4.838C236.3 3.356 238.365 3 240.458 3c2.973 0 5.74.656 8.302 1.968 2.56 1.312 4.72 3.116 6.483 5.412h.083c.716.984 1.404 2.186 2.065 3.608-.66-1.422-1.348-2.624-2.064-3.608h-.083c.882 1.202 1.598 2.405 2.148 3.608h-16.933c-1.763 0-3.32.56-4.668 1.68-1.35 1.12-2.19 2.53-2.52 4.223l-6.444-10.904z"
    />
  </svg>
);

Chrome.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Chrome.defaultProps = {
  color: WHITE,
  width: 37,
};

export default Chrome;
